import { render, staticRenderFns } from "./ConfigurationAccessControlTemplate.vue?vue&type=template&id=6b57a7b9&"
import script from "./ConfigurationAccessControlTemplate.vue?vue&type=script&lang=js&"
export * from "./ConfigurationAccessControlTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationAccessControlTemplate.vue?vue&type=style&index=0&id=6b57a7b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports